import axios, { AxiosResponse } from 'axios';
import { getHostApi, getRequestConfig } from "../utils";
import { Customer, CustomerV2, FormUpdateCustomer } from '../components/mon-compte/iMonCompte';
import { ResponseData } from '../interfaces-base';
import { getUserId } from '../components/mon-compte/MonCompteAction';
type CustomerV1Response = { customer: Customer };

export async function fetchCustomerById(): Promise<AxiosResponse<CustomerV1Response>> {
  return axios.get<CustomerV1Response>(`${getHostApi()}/customers/${getUserId()}`, getRequestConfig());
}

export async function fetchCustomerByIdV2(): Promise<AxiosResponse<ResponseData<CustomerV2>>> {
  return axios.get<ResponseData<CustomerV2>>(`${getHostApi()}/v2/customers/${getUserId()}`, getRequestConfig());
}

export async function updateCustomer(form: Customer): Promise<AxiosResponse> {
  return axios.put(`${getHostApi()}/customers/${getUserId()}`, form, getRequestConfig());
}

export async function updateCustomerV2(form: FormUpdateCustomer): Promise<AxiosResponse> {
  return axios.put(`${getHostApi()}/v2/customers/${getUserId()}`, form, getRequestConfig());
}